import { useState } from 'react';
import { Link } from 'react-router-dom';
import { products, categories } from '@/mocks/products';
import { FadeInSection } from '@/hooks/useAnimation';

export default function ProductShowcase() {
  const [activeTab, setActiveTab] = useState('all');
  const displayedProducts = activeTab === 'all'
    ? products.slice(0, 6)
    : products.filter((p) => p.categorySlug === activeTab).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <FadeInSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              精选时令瓜果
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              严选全国优质产区，每一颗瓜都经过严格筛选，只为给您最甜蜜的体验
            </p>
          </div>
        </FadeInSection>

        <FadeInSection delay={100}>
          <div className="flex items-center justify-center mb-8 md:mb-10">
            <div className="inline-flex bg-background-100 rounded-full px-1 py-1 flex-wrap justify-center gap-1">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveTab(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTab === cat.slug
                      ? 'bg-primary-500 text-background-50 shadow-md'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {displayedProducts.map((product, index) => (
            <FadeInSection key={product.id} delay={index * 100} direction="up">
              <div
                key={product.id}
                className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden bg-background-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {product.badge && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                      {product.badge}
                    </span>
                  )}
                  {product.inSeason && (
                    <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-600 text-xs font-medium">
                      当季
                    </span>
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className="font-heading text-lg text-foreground-900">{product.name}</h3>
                    <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {product.origin}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                    {product.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {product.features.slice(0, 3).map((feat, i) => (
                      <span key={i} className="text-xs px-2 py-0.5 rounded-full bg-accent-50 text-accent-700">
                        {feat}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-xl font-bold text-primary-600">¥{product.price}</span>
                      <span className="text-xs text-foreground-400 ml-1">/{product.unit}</span>
                    </div>
                    <Link
                      to="/category"
                      className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      立即购买
                    </Link>
                  </div>
                </div>
              </div>
            </FadeInSection>
          ))}
        </div>

        <FadeInSection delay={300}>
          <div className="text-center mt-8 md:mt-10">
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-semibold hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              查看全部瓜果
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}